'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { cn } from '@achra/ui/lib/utils';
import { ChevronDown } from 'lucide-react';
import { motion } from 'motion/react';
import { useState } from 'react';
import { Markdown } from '@/modules/shared/components/markdown/markdown';
interface ExpandableSectionProps {
  title: string;
  description: string;
}
function ExpandableSection(t0) {
  const $ = _c(29);
  const {
    title,
    description
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsOpen(_temp);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const toggleSection = t1;
  let t2;
  if ($[1] !== title) {
    t2 = <span className="text-ring text-sm/5.5 font-medium lg:text-base/6 lg:font-semibold">{title}</span>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !isOpen;
  let t4;
  if ($[3] !== isOpen || $[4] !== t3) {
    t4 = cn("text-foreground size-4 transition-transform duration-300 ease-out", {
      "rotate-180": isOpen,
      "rotate-0": t3
    });
    $[3] = isOpen;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <Button variant="icon" size="iconXsm"><ChevronDown className={t4} /></Button>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <div className="bg-popover flex cursor-pointer items-center justify-between gap-4 rounded-lg px-3 py-2 shadow-lg" onClick={toggleSection}>{t2}{t5}</div>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      opacity: 0,
      height: 0,
      marginBottom: 0
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = isOpen ? 1 : 0;
  const t9 = isOpen ? "auto" : 0;
  const t10 = isOpen ? "calc(var(--spacing) * 2)" : 0;
  let t11;
  if ($[12] !== t10 || $[13] !== t8 || $[14] !== t9) {
    t11 = {
      opacity: t8,
      height: t9,
      marginTop: t10
    };
    $[12] = t10;
    $[13] = t8;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      duration: 0.3,
      ease: "easeInOut"
    };
    t13 = {
      duration: 0.3,
      ease: "easeInOut"
    };
    $[16] = t12;
    $[17] = t13;
  } else {
    t12 = $[16];
    t13 = $[17];
  }
  const t14 = isOpen ? 0.5 : 0.1;
  let t15;
  if ($[18] !== t14) {
    t15 = {
      duration: 0.3,
      ease: "easeInOut",
      height: t12,
      marginTop: t13,
      opacity: {
        duration: t14,
        ease: "easeInOut"
      }
    };
    $[18] = t14;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== description) {
    t16 = <Markdown className="text-foreground">{description}</Markdown>;
    $[20] = description;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== t11 || $[23] !== t15 || $[24] !== t16) {
    t17 = <motion.div className="overflow-hidden" initial={t7} animate={t11} transition={t15}>{t16}</motion.div>;
    $[22] = t11;
    $[23] = t15;
    $[24] = t16;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== t17 || $[27] !== t6) {
    t18 = <div className="flex flex-col gap-2">{t6}{t17}</div>;
    $[26] = t17;
    $[27] = t6;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  return t18;
}
function _temp(prev) {
  return !prev;
}
export { ExpandableSection };